type DecimalValue = string | number | null | undefined;

/** 独立确认件只读展示保留全部有效小数，全程按文本去零和整数分组，不参与金额计算。 */
export function formatConfirmationDecimal(value: DecimalValue, grouped = false): string {
  const text = value == null ? "" : String(value).trim();
  const match = /^(-?)(\d+)(?:\.(\d+))?$/.exec(text);
  if (!match) return "—";
  const whole = match[2].replace(/^0+(?=\d)/, "");
  const fraction = (match[3] || "").replace(/0+$/, "");
  const sign = match[1] && (whole !== "0" || fraction) ? "-" : "";
  return `${sign}${grouped ? whole.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : whole}${fraction ? `.${fraction}` : ""}`;
}

/** 独立确认件金额展示，缺失和非法值不冒充零；共享功能的默认格式保持不变。 */
export function formatConfirmationAmount(value: DecimalValue, signed = false): string {
  const amount = formatConfirmationDecimal(value, true);
  if (amount === "—") return amount;
  if (signed && amount.startsWith("-")) return `−¥${amount.slice(1)}`;
  return `${signed && amount !== "0" ? "+" : ""}¥${amount}`;
}

/** 只初始化可编辑十进制文本，不加千分位，非法原文仍留给原业务校验。 */
export function confirmationDecimalInput(value: string | null | undefined): string {
  const formatted = formatConfirmationDecimal(value);
  return formatted === "—" ? value ?? "" : formatted;
}
